var canaryConfig = {
    aadUrl: 'https://login.microsoftonline.com/',
    agreementApi: 'https://main.prod.marketplaceagreement.azure.com',
    agreementAppId: '5b93104f-32d5-4dcc-a480-72f0a10b1afa',
    appsourceUrl: 'https://appgallery.spza-canary.net',
    azureManagementApi: 'https://management.azure.com',
    commerceAppId: '982bda36-4632-4165-a46a-9863b1bbcf7d',
    graphApi: 'https://graph.microsoft.com',
    i18nResources: 'https://static.canary.cloudmarketplace.microsoft.com/localization',
    jarvisApi: 'https://jarvisapi.account.microsoft.com',
    marketplaceLeadsAppId: 'c44b4083-3bb0-49c1-b47d-974e53cbdf3c',
    marketplaceLeadsUrl: 'https://main.prod.marketplaceleads.azure.com',
    partnersApi: 'https://main.canary.marketplacepartnerdirectory.azure.net/api',
    pifdApi: 'https://paymentinstruments.mp.microsoft.com',
    searchApi: 'https://euap.catalogapi.azure.com',
    telemetryEnv: 'CANARY'
};

export { canaryConfig };
